import { faAngleDoubleRight } from "@fortawesome/pro-solid-svg-icons/faAngleDoubleRight";
import { faAngleDown } from "@fortawesome/pro-solid-svg-icons/faAngleDown";
import { faAngleLeft } from "@fortawesome/pro-solid-svg-icons/faAngleLeft";
import { faAngleRight } from "@fortawesome/pro-solid-svg-icons/faAngleRight";
import { faAngleUp } from "@fortawesome/pro-solid-svg-icons/faAngleUp";
import { faBabyCarriage } from "@fortawesome/pro-solid-svg-icons/faBabyCarriage";
import { faBadgeCheck } from "@fortawesome/pro-solid-svg-icons/faBadgeCheck";
import { faBan } from "@fortawesome/pro-solid-svg-icons/faBan";
import { faBuilding } from "@fortawesome/pro-solid-svg-icons/faBuilding";
import { faCalendarEdit } from "@fortawesome/pro-solid-svg-icons/faCalendarEdit";
import { faCar } from "@fortawesome/pro-solid-svg-icons/faCar";
import { faCaretDown } from "@fortawesome/pro-solid-svg-icons/faCaretDown";
import { faCaretUp } from "@fortawesome/pro-solid-svg-icons/faCaretUp";
import { faCheck } from "@fortawesome/pro-solid-svg-icons/faCheck";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons/faCheckCircle";
import { faCheckDouble } from "@fortawesome/pro-solid-svg-icons/faCheckDouble";
import { faChevronDown } from "@fortawesome/pro-solid-svg-icons/faChevronDown";
import { faChevronLeft } from "@fortawesome/pro-solid-svg-icons/faChevronLeft";
import { faChevronRight } from "@fortawesome/pro-solid-svg-icons/faChevronRight";
import { faChevronUp } from "@fortawesome/pro-solid-svg-icons/faChevronUp";
import { faChild } from "@fortawesome/pro-solid-svg-icons/faChild";
import { faCircle } from "@fortawesome/pro-solid-svg-icons/faCircle";
import { faCity } from "@fortawesome/pro-solid-svg-icons/faCity";
import { faClipboardPrescription } from "@fortawesome/pro-solid-svg-icons/faClipboardPrescription";
import { faCog } from "@fortawesome/pro-solid-svg-icons/faCog";
import { faComments } from "@fortawesome/pro-solid-svg-icons/faComments";
import { faCopy } from "@fortawesome/pro-solid-svg-icons/faCopy";
import { faCreditCard } from "@fortawesome/pro-solid-svg-icons/faCreditCard";
import { faDollarSign } from "@fortawesome/pro-solid-svg-icons/faDollarSign";
import { faDownload } from "@fortawesome/pro-solid-svg-icons/faDownload";
import { faEdit } from "@fortawesome/pro-solid-svg-icons/faEdit";
import { faEllipsisV } from "@fortawesome/pro-solid-svg-icons/faEllipsisV";
import { faEnvelope } from "@fortawesome/pro-solid-svg-icons/faEnvelope";
import { faExclamationCircle } from "@fortawesome/pro-solid-svg-icons/faExclamationCircle";
import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons/faExclamationTriangle";
import { faExternalLink } from "@fortawesome/pro-solid-svg-icons/faExternalLink";
import { faExternalLinkAlt } from "@fortawesome/pro-solid-svg-icons/faExternalLinkAlt";
import { faEye } from "@fortawesome/pro-solid-svg-icons/faEye";
import { faFileAlt } from "@fortawesome/pro-solid-svg-icons/faFileAlt";
import { faFileEdit } from "@fortawesome/pro-solid-svg-icons/faFileEdit";
import { faFileInvoiceDollar } from "@fortawesome/pro-solid-svg-icons/faFileInvoiceDollar";
import { faFilePlus } from "@fortawesome/pro-solid-svg-icons/faFilePlus";
import { faFolderOpen } from "@fortawesome/pro-solid-svg-icons/faFolderOpen";
import { faFrown } from "@fortawesome/pro-solid-svg-icons/faFrown";
import { faGlasses } from "@fortawesome/pro-solid-svg-icons/faGlasses";
import { faGrin } from "@fortawesome/pro-solid-svg-icons/faGrin";
import { faGrinHearts } from "@fortawesome/pro-solid-svg-icons/faGrinHearts";
import { faHandHoldingHeart } from "@fortawesome/pro-solid-svg-icons/faHandHoldingHeart";
import { faHeadset } from "@fortawesome/pro-solid-svg-icons/faHeadset";
import { faHeart } from "@fortawesome/pro-solid-svg-icons/faHeart";
import { faHospitalUser } from "@fortawesome/pro-solid-svg-icons/faHospitalUser";
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons/faInfoCircle";
import { faLifeRing } from "@fortawesome/pro-solid-svg-icons/faLifeRing";
import { faLocation } from "@fortawesome/pro-solid-svg-icons/faLocation";
import { faLock } from "@fortawesome/pro-solid-svg-icons/faLock";
import { faLongArrowAltRight } from "@fortawesome/pro-solid-svg-icons/faLongArrowAltRight";
import { faMagic } from "@fortawesome/pro-solid-svg-icons/faMagic";
import { faMedkit } from "@fortawesome/pro-solid-svg-icons/faMedkit";
import { faMeh } from "@fortawesome/pro-solid-svg-icons/faMeh";
import { faMinusCircle } from "@fortawesome/pro-solid-svg-icons/faMinusCircle";
import { faMoneyBill } from "@fortawesome/pro-solid-svg-icons/faMoneyBill";
import { faMoneyCheckAlt } from "@fortawesome/pro-solid-svg-icons/faMoneyCheckAlt";
import { faMountains } from "@fortawesome/pro-solid-svg-icons/faMountains";
import { faPencilAlt } from "@fortawesome/pro-solid-svg-icons/faPencilAlt";
import { faPhone } from "@fortawesome/pro-solid-svg-icons/faPhone";
import { faPlane } from "@fortawesome/pro-solid-svg-icons/faPlane";
import { faPlus } from "@fortawesome/pro-solid-svg-icons/faPlus";
import { faPlusCircle } from "@fortawesome/pro-solid-svg-icons/faPlusCircle";
import { faPrescriptionBottleAlt } from "@fortawesome/pro-solid-svg-icons/faPrescriptionBottleAlt";
import { faPrint } from "@fortawesome/pro-solid-svg-icons/faPrint";
import { faQuestionCircle } from "@fortawesome/pro-solid-svg-icons/faQuestionCircle";
import { faRepeat } from "@fortawesome/pro-solid-svg-icons/faRepeat";
import { faRunning } from "@fortawesome/pro-solid-svg-icons/faRunning";
import { faSearch } from "@fortawesome/pro-solid-svg-icons/faSearch";
import { faShoppingCart } from "@fortawesome/pro-solid-svg-icons/faShoppingCart";
import { faSignOutAlt } from "@fortawesome/pro-solid-svg-icons/faSignOutAlt";
import { faSmile } from "@fortawesome/pro-solid-svg-icons/faSmile";
import { faSpinner } from "@fortawesome/pro-solid-svg-icons/faSpinner";
import { faSpinnerThird } from "@fortawesome/pro-solid-svg-icons/faSpinnerThird";
import { faStar } from "@fortawesome/pro-solid-svg-icons/faStar";
import { faStarHalfAlt } from "@fortawesome/pro-solid-svg-icons/faStarHalfAlt";
import { faStethoscope } from "@fortawesome/pro-solid-svg-icons/faStethoscope";
import { faSync } from "@fortawesome/pro-solid-svg-icons/faSync";
import { faSyncAlt } from "@fortawesome/pro-solid-svg-icons/faSyncAlt";
import { faTh } from "@fortawesome/pro-solid-svg-icons/faTh";
import { faTimes } from "@fortawesome/pro-solid-svg-icons/faTimes";
import { faTimesCircle } from "@fortawesome/pro-solid-svg-icons/faTimesCircle";
import { faTooth } from "@fortawesome/pro-solid-svg-icons/faTooth";
import { faTrash } from "@fortawesome/pro-solid-svg-icons/faTrash";
import { faTrophy } from "@fortawesome/pro-solid-svg-icons/faTrophy";
import { faUniversity } from "@fortawesome/pro-solid-svg-icons/faUniversity";
import { faUnlock } from "@fortawesome/pro-solid-svg-icons/faUnlock";
import { faUpload } from "@fortawesome/pro-solid-svg-icons/faUpload";
import { faUser } from "@fortawesome/pro-solid-svg-icons/faUser";
import { faUserInjured } from "@fortawesome/pro-solid-svg-icons/faUserInjured";
import { faUserMd } from "@fortawesome/pro-solid-svg-icons/faUserMd";
import { faUserPlus } from "@fortawesome/pro-solid-svg-icons/faUserPlus";
import { faUsers } from "@fortawesome/pro-solid-svg-icons/faUsers";
import { faWheelchair } from "@fortawesome/pro-solid-svg-icons/faWheelchair";
import { faWrench } from "@fortawesome/pro-solid-svg-icons/faWrench";

export default {
  "angle-double-right": faAngleDoubleRight,
  "angle-down": faAngleDown,
  "angle-left": faAngleLeft,
  "angle-right": faAngleRight,
  "angle-up": faAngleUp,
  "badge-check": faBadgeCheck,
  "baby-carriage": faBabyCarriage,
  "calendar-edit": faCalendarEdit,
  "caret-down": faCaretDown,
  "caret-up": faCaretUp,
  "check-circle": faCheckCircle,
  "check-double": faCheckDouble,
  "chevron-down": faChevronDown,
  "chevron-left": faChevronLeft,
  "chevron-right": faChevronRight,
  "chevron-up": faChevronUp,
  "circle-xmark": faTimesCircle,
  "clipboard-prescription": faClipboardPrescription,
  "credit-card": faCreditCard,
  "dollar-sign": faDollarSign,
  "ellipsis-v": faEllipsisV,
  "exclamation-circle": faExclamationCircle,
  "exclamation-triangle": faExclamationTriangle,
  "external-link-alt": faExternalLinkAlt,
  "external-link": faExternalLink,
  // multiple names: external-link === arrow-up-right-from-square
  "file-alt": faFileAlt,
  "file-edit": faFileEdit,
  "file-invoice-dollar": faFileInvoiceDollar,
  "file-plus": faFilePlus,
  "folder-open": faFolderOpen,
  "hand-holding-heart": faHandHoldingHeart,
  "hospital-user": faHospitalUser,
  "info-circle": faInfoCircle,
  "life-ring": faLifeRing,
  // multiple names: life-saver === life-ring
  "life-saver": faLifeRing,
  // multiple names: life-saver === life-ring
  "long-arrow-alt-right": faLongArrowAltRight,
  "minus-circle": faMinusCircle,
  "money-bill": faMoneyBill,
  "money-check-alt": faMoneyCheckAlt,
  "pencil-alt": faPencilAlt,
  "plus-circle": faPlusCircle,
  "prescription-bottle-alt": faPrescriptionBottleAlt,
  "question-circle": faQuestionCircle,
  "shopping-cart": faShoppingCart,
  "sign-out-alt": faSignOutAlt,
  "spinner-third": faSpinnerThird,
  "star-half-alt": faStarHalfAlt,
  "sync-alt": faSyncAlt,
  // refresh === sync-alt
  "times-circle": faTimesCircle,
  "user-injured": faUserInjured,
  "user-md": faUserMd,
  "user-plus": faUserPlus,
  ban: faBan,
  building: faBuilding,
  car: faCar,
  check: faCheck,
  child: faChild,
  circle: faCircle,
  city: faCity,
  copy: faCopy,
  cog: faCog,
  comments: faComments,
  download: faDownload,
  edit: faEdit,
  envelope: faEnvelope,
  eye: faEye,
  frown: faFrown,
  glasses: faGlasses,
  grin: faGrin,
  grinHearts: faGrinHearts,
  headset: faHeadset,
  heart: faHeart,
  location: faLocation,
  lock: faLock,
  magic: faMagic,
  medkit: faMedkit,
  meh: faMeh,
  mountains: faMountains,
  phone: faPhone,
  plane: faPlane,
  plus: faPlus,
  print: faPrint,
  refresh: faSyncAlt,
  repeat: faRepeat,
  // refresh === sync-alt
  running: faRunning,
  search: faSearch,
  smile: faSmile,
  spinner: faSpinner,
  star: faStar,
  stethoscope: faStethoscope,
  sync: faSync,
  th: faTh,
  times: faTimes,
  tooth: faTooth,
  trash: faTrash,
  trophy: faTrophy,
  university: faUniversity,
  unlock: faUnlock,
  upload: faUpload,
  user: faUser,
  users: faUsers,
  wheelchair: faWheelchair,
  wrench: faWrench,
};
